// extracted by mini-css-extract-plugin
export var button = "_b3-4";
export var hasDarkBackground = "_b3-7";
export var hasLightBackground = "_b3-6";
export var iconWrapper = "_b3-0";
export var large = "_b3-2";
export var medium = "_b3-1";
export var small = "_b3-5";
export var xsmall = "_b3-3";